import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config/api";
import "./AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    setError("");
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/admin/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Invalid email or password"
        );
      }

      localStorage.setItem("adminToken", data.token);
      localStorage.setItem(
        "adminData",
        JSON.stringify(data.admin)
      );

      navigate("/admin/dashboard");
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="tv-admin-login">
      <div className="tv-admin-login-glow"></div>

      <div className="tv-admin-login-card">
        <div className="tv-admin-login-brand">
          <img
            src="/images/logo.png"
            alt="Time Valley"
          />

          <span>ADMINISTRATION</span>
        </div>

        <div className="tv-admin-login-heading">
          <span>TIME VALLEY WATCHES</span>

          <h1>
            Welcome
            <br />
            <em>Back.</em>
          </h1>

          <p>
            Sign in to access your Time Valley
            administration panel.
          </p>
        </div>

        {error && (
          <div className="tv-admin-login-error">
            {error}
          </div>
        )}

        <form
          className="tv-admin-login-form"
          onSubmit={handleLogin}
        >
          <div className="tv-admin-field">
            <label htmlFor="admin-email">
              Email Address
            </label>

            <input
              id="admin-email"
              type="email"
              placeholder="admin@timevalley.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="tv-admin-field">
            <label htmlFor="admin-password">
              Password
            </label>

            <div className="tv-admin-password-wrap">
              <input
                id="admin-password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={
                  showPassword
                    ? "Hide password"
                    : "Show password"
                }
              >
                {showPassword ? "HIDE" : "SHOW"}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="tv-admin-login-button"
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}

            {!loading && <span>→</span>}
          </button>
        </form>

        <div className="tv-admin-login-footer">
          <span>TIME VALLEY</span>
          <span>PRIVATE ADMINISTRATION</span>
        </div>
      </div>
    </main>
  );
}

export default AdminLogin;
